import React, { useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import { useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslation } from "react-i18next";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import "../assets/css/SideBar.css";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { NavLink } from "react-router-dom";
import ViewListIcon from "@mui/icons-material/ViewList";
import { Toolbar, IconButton, Box, Menu, MenuItem } from "@mui/material";
import LoginPc from "../assets/images/computer.png";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import ChangePasswordModal from "./ChangePasswordModal";
import LogoutModal from "./LogOutModal";
import SummarizeIcon from "@mui/icons-material/Summarize";
import PostAddIcon from "@mui/icons-material/PostAdd";
import TranslateIcon from "@mui/icons-material/Translate";
import HomeIcon from "@mui/icons-material/Home";
import StarPurple500Icon from "@mui/icons-material/StarPurple500";
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, i18n }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: i18n.language === "ar" ? `0` : `${drawerWidth}px`, // إذا كانت اللغة عربية، marginLeft يكون 0، إذا كانت إنجليزية، يكون drawerWidth
    marginRight: i18n.language === "ar" ? `${drawerWidth}px` : `0`,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

export default function SideBar() {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [logoutDialog, setLogoutDialog] = useState(false);
  const location = useLocation();
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleOpenLogoutDialog = () => {
    setLogoutDialog(true);
  };

  const handleCloseLogoutDialog = () => {
    setLogoutDialog(false);
  };

  const handleLogout = () => {
    console.log("User logged out");
    setLogoutDialog(false);
  };

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const userData = JSON.parse(localStorage.getItem("userData"));
  const roleID = userData?.Data?.RoleID;
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    handleCloseMenu();
  };
  const isRtl = i18n.language === "ar";
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        i18n={i18n}
        sx={{
          backgroundColor: "#1e293b",
          boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={[
              {
                marginRight: i18n.language === "ar" ? 0 : 3,
                marginLeft: i18n.language === "ar" ? 3 : 0,
              },
              open && { display: "none" },
            ]}
          >
            <MenuIcon />
          </IconButton>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#ffffff",
              padding: "5px 12px",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.12)",
            }}
          >
            <img
              src={LoginPc}
              alt="Tarabot Logo"
              style={{ height: "36px", width: "auto", display: "block" }}
            />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <IconButton
            color="inherit"
            aria-label="translate"
            onClick={handleOpenMenu}
          >
            <TranslateIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            <MenuItem onClick={() => handleLanguageChange("en")}>
              English
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange("ar")}>عربي</MenuItem>
          </Menu>
          <IconButton
            color="inherit"
            aria-label="account"
            onClick={handleOpenDialog}
          >
            <AccountCircleIcon />
          </IconButton>

          <IconButton
            color="inherit"
            aria-label="logout"
            onClick={handleOpenLogoutDialog}
          >
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open} anchor={isRtl ? "right" : "left"}>
        <DrawerHeader>
          <IconButton
            onClick={handleDrawerClose}
            sx={{ backgroundColor: "#1e293b", color: "white", "&:hover": { backgroundColor: "#0f172a" } }}
          >
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        <List>
          {roleID === 1 ? (
            <>
              <ListItem disablePadding>
                <ListItemButton
                  component={NavLink}
                  to="/home-page"
                  onClick={handleDrawerClose}
                >
                  <ListItemIcon>
                    <HomeIcon sx={{ color: "#2563eb" }} />
                  </ListItemIcon>
                  <ListItemText sx={{ color: "#334155", fontWeight: 600 }}>
                    {t("homePage")}
                  </ListItemText>
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton
                  component={NavLink}
                  to="/add-user"
                  onClick={handleDrawerClose}
                >
                  <ListItemIcon>
                    <PersonAddAlt1Icon sx={{ color: "#2563eb" }} />
                  </ListItemIcon>
                  <ListItemText sx={{ color: "#334155", fontWeight: 600 }}>
                    {t("addUser")}
                  </ListItemText>
                </ListItemButton>
              </ListItem>

              <ListItem disablePadding>
                <ListItemButton
                  component={NavLink}
                  to="/all-user"
                  onClick={handleDrawerClose}
                >
                  <ListItemIcon>
                    <ViewListIcon sx={{ color: "#2563eb" }} />
                  </ListItemIcon>
                  <ListItemText sx={{ color: "#334155", fontWeight: 600 }}>
                    {t("allUser")}
                  </ListItemText>
                </ListItemButton>
              </ListItem>

              <ListItem disablePadding>
                <ListItemButton
                  component={NavLink}
                  to="/all-calls"
                  onClick={handleDrawerClose}
                >
                  <ListItemIcon>
                    <SummarizeIcon sx={{ color: "#2563eb" }} />
                  </ListItemIcon>
                  <ListItemText sx={{ color: "#334155", fontWeight: 600 }}>
                    {t("allCalls")}
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </>
          ) : roleID === 2 ? (
            <>
              <ListItem disablePadding>
                <ListItemButton
                  component={NavLink}
                  to="/cs-home"
                  onClick={handleDrawerClose}
                >
                  <ListItemIcon>
                    <PostAddIcon sx={{ color: "#2563eb" }} />
                  </ListItemIcon>
                  <ListItemText sx={{ color: "#334155", fontWeight: 600 }}>
                    {t("addCall")}
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </>
          ) : null}
        </List>

        <Divider />
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          backgroundColor: "white",
          padding: "0",
        }}
      >
        {location.pathname === "/home-page" && roleID === 1 && (
          <iframe
            src="https://mps1.com-eg.net/bi/site/tarabotdashboard/dashboards/2069d749-33fb-4e98-ad98-2d3c37a4bdd1/Tarabot/Tarabot"
            width="99%"
            height="565px"
            style={{
              border: "none",
              marginTop: "70px",
              marginLeft: i18n.language === "ar" ? "5px" : "0", // إذا كانت اللغة عربية، يكون marginLeft 5px
              marginRight: i18n.language === "ar" ? "0" : "5px", // إذا كانت اللغة عربية، يكون marginRight 0
              maxHeight: "800px",
            }}
            title="Dashboard"
          />
        )}
      </Box>
      <ChangePasswordModal open={openDialog} handleClose={handleCloseDialog} />
      <LogoutModal
        open={logoutDialog}
        handleClose={handleCloseLogoutDialog}
        handleLogout={handleLogout}
      />
    </Box>
  );
}
